export enum ModuleType {
  TenantManagement,
  UserManagement,
  ProcessManagement,
  FactoryHeadUserManagement,
  AIMSPortal,
  HolidayCalendar,
  ProcessTemplateManagement,
  TeplarPrintTemplateManagement,
  ProductManagement,
  TrayManagement,
  GroupManagement,
  ProductionManagerUserManagement,
  ActiveTrayManagement,
  OrderViewDashboard,
  HKRScheduleView,
  KishuManagement,
  OperatorMenu,
  FactoryAccess,
  UserLogs,
  DimensionTableFields,
  CheckItemTemplate,
  TrayTagReassignment,
  BomSearch,
  ToolManagement,
  NonConformity,
  ToolCheckItemTemplate,
  DefectiveItems,
  CrimpingInspectionRecord,
  UserCreatedInspectionRecord,
  ToolBOM
}
